module.exports = __webpack_public_path__ + "static/109_001-22e605ddb6ef029b846a274057315f34.jpg";